import { createSlice } from '@reduxjs/toolkit';
import { generateMeeting, meetDisconnect } from './googleThunk';

const googleSlice = createSlice({
    name: 'google',
    initialState: {
        generateMeetingLoading: true,
        generateMeetingError: null,
        generateMeetingFulfill: null,
        disconnectLoading: false,
        disconnectError: null,
        disconnectSuccess: null,
    },
    reducers: {
        resetGoogleAuth: (state) => {
            state.generateMeetingLoading = null;
            state.generateMeetingError = null;
            state.generateMeetingFulfill = null;
            state.disconnectLoading = false;
            state.disconnectError = null;
            state.disconnectSuccess = null;
        },
    },
    extraReducers: (builder) => {
        // Handle generateMeeting actions
        builder
            .addCase(generateMeeting.pending, (state) => {
                state.generateMeetingLoading = true;
            })
            .addCase(generateMeeting.fulfilled, (state, action) => {
                state.generateMeetingLoading = false;
                state.generateMeetingFulfill = action.payload;
            })
            .addCase(generateMeeting.rejected, (state, action) => {
                state.generateMeetingLoading = false;
                state.generateMeetingError = action.payload;
            })
            
            // Handle meetDisconnect actions
            .addCase(meetDisconnect.pending, (state) => {
                state.disconnectLoading = true;
                state.disconnectError = null;
                state.disconnectSuccess = null;
            })
            .addCase(meetDisconnect.fulfilled, (state, action) => {
                state.disconnectLoading = false;
                state.disconnectSuccess = action.payload;
            })
            .addCase(meetDisconnect.rejected, (state, action) => {
                state.disconnectLoading = false;
                state.disconnectError = action.payload;
            });
    },
});
export const { resetGoogleAuth } = googleSlice.actions;
// Export the reducer
export default googleSlice.reducer;
